import Http from 'axios'
import {
    VERSIONED_API_URL
} from '../../config/config'

function initialState() {
    return {
        all: [],
        allRoles: [],
        query: '',
        totalNumber: 0,
        filter: '',
        loading: false,
        role: {}
    }
}

const getters = {
    all: state => state.all,
    allRoles: state => state.allRoles,
    loading: state => state.loading,
    filter: state => state.filter,
    query: state => state.query,
    role: state => state.role,
    totalNumber: state => state.totalNumber
}

const actions = {

    fetchData({state}) {
        Http.get(`${VERSIONED_API_URL}/roles?all`, {
            params: state.filter
        }).then((response) => {
            state.all = response.data;
            if(!state.filter)
                state.allRoles =  response.data;
        })
    },

    resetState({commit}) {
        commit('resetState')
    }
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setRole(state, role) {
        state.role = role
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
